module.exports = __webpack_public_path__ + "media/stylesheets/images/media/user_way_introduction-4d1094ce49627f49b49df5ef49c1460b.png";